import {Injectable} from '@angular/core';
import {FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

/**
 * 羽数入力欄向けの ErrorStateMatcher
 *
 * 羽数欄では入力直後からエラーを表示する。
 * 全 Material 入力へ影響させないよう、羽数欄にのみ適用する。
 */
@Injectable({providedIn: 'root'})
export class WasuuErrorStateMatcher implements ErrorStateMatcher {
  /**
   * エラー表示に切り替えるかどうかを判定する
   * @param control 対象のFormControl
   * @param form 所属するフォーム
   * @returns {boolean} エラー表示にするなら true
   */
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control?.invalid && (control.dirty || control.touched || form?.submitted));
  }
}
